export { default } from "./UserBadgeWithAvatar.vue";
